import { render } from "./NlpAccountCreate.vue?vue&type=template&id=0db1cc53&scoped=true"
import script from "./NlpAccountCreate.vue?vue&type=script&lang=js"
export * from "./NlpAccountCreate.vue?vue&type=script&lang=js"

import "./NlpAccountCreate.vue?vue&type=style&index=0&id=0db1cc53&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db1cc53"]])

export default __exports__